import { CartState } from "@State/app.state";
import { createReducer, on } from "@ngrx/store";
import * as CartActions from "@Actions/cart.actions"
import { CartTicket } from "@Interfaces/interfaces";

const cartInitialState: CartState = {
  tickets: [],
  total: 0
};


export const cartReducer = createReducer(
  cartInitialState,
  on(CartActions.addTicketToCart, (state, { ticket }) => {

    const existingTicket = state.tickets.findIndex( t =>
      t.idoff === ticket.idoff &&
      t.date === ticket.date &&
      t.idFascia === ticket.idFascia
    );

    if(existingTicket !== -1){
      const updatedTickets = state.tickets.map((t, index) =>
        index === existingTicket ? {...t, counter: ticket.counter} : t
      );

      const newTotal = updatedTickets.reduce((sum, t) => sum + (t.prezzo * t.counter), 0);

      return { ...state, tickets: updatedTickets, total: newTotal };

    } else {

      let updatedTickets = [...state.tickets, ticket];
      const newTotal = updatedTickets.reduce((sum, t) => sum + (t.prezzo * t.counter), 0);
      return { ...state, tickets: updatedTickets, total: newTotal }

    };

  }),
  on(CartActions.removeTicketFromCart, (state, { ticket }) => {

    let updatedTickets = state.tickets.filter(t =>
      t.idoff !== ticket.idoff
    );
    const newTotal = updatedTickets.reduce((sum, t) => sum + (t.prezzo * t.counter), 0);

    return { ...state, tickets: updatedTickets, total: newTotal };
  }),
  on(CartActions.clearCart, (state) => {
    return cartInitialState;
  }),
  on(CartActions.addPassInfoToTicket, (state, {passInfo}) => {
    let updatedTickets = state.tickets;
    updatedTickets = [{...updatedTickets.at(0),passInfo:passInfo} as CartTicket];
    return {...state, tickets: updatedTickets};
  })
)
